/**
 * Nested menu.
 *
 * This code is common for horizontal and vertical nested menus.
 */
(() => {
    function menu_nested(args) {
        let menu = args.menu;

        if (!menu) {
            return;
        }

        /**
         * Event: Menu caret clicked
         *
         * Open sub-menu and change caret state
         */
        function caretClicked(e) {
            // console.log('Menu caret clicked');

            const li = e.currentTarget.closest('.menu-item-has-children');

            // do not proceed if the item is on cooldown
            // please check where cooldowns are added for the reasoning behind this
            if (H_Tools.nestedmenu.isOnCooldown(li)) {
                return;
            }

            const result = H_Tools.nestedmenu.toggleMenuItem(menu, li);

            if (result > 0) {
                li.dispatchEvent(new Event('caretopened'));
            }

            // don't trigger parent(s)
            e.stopPropagation();
        }

        /**
         * Event: Click on empty link (a[href="#"])
         */
        function emptyLinkClicked(e) {
            // cancel default action
            e.preventDefault();

            const li = e.currentTarget.closest('.menu-item-has-children');
            if (li) {
                if (li.classList.contains('-is-clicked')) {
                    H_Tools.nestedmenu.deactivateMenuItem(li);
                    li.classList.remove('-is-clicked');
                } else {
                    H_Tools.nestedmenu.activateMenuItem(menu, li);
                    li.classList.add('-is-clicked');
                }
            }
        }

        // close all menus
        H_Tools.nestedmenu.resetMenuItems(menu);

        // setup click hooks (carets)
        menu.querySelectorAll('.js-menu-caret').forEach((caret) => {
            caret.addEventListener('click', caretClicked);
        });

        // setup click hooks (empty links)
        menu.querySelectorAll('a:not([href])').forEach((link) => {
            link.addEventListener('click', emptyLinkClicked);
            link.setAttribute('aria-hidden', true);
        });
    }

    document.querySelectorAll('.js-menu-nested').forEach((menu) => {
        menu_nested({
            menu: menu,
        });
    });
})();
